









































































































































import Routes from '@/Routes';
import { Component, Vue, Watch } from 'vue-property-decorator';
import AppEvents from '@/AppEvents';
import { RouteConfig } from 'vue-router';
import User from '@/models/User';
import IApiError from '@/models/IApiError';

@Component({
  components: {
  },
})
export default class SignInPage extends Vue {
  signingInWithPassword: boolean = false;
  signingInWithAzureAd: boolean = false;
  passwordVisible: boolean = false;
  apiErrors: IApiError[] = [];
  model: any = {
      username: '',
      password: ''
  }

  $tlang: any;

  setLocale(locale){
    this.$store.dispatch("app/setLocale", locale);
  }

  get forgotPasswordRoute(): RouteConfig {
    return Routes.forgotPasswordRoute;
  }

  get isAuthenticated() {
    return this.$store.getters["auth/isAuthenticated"];
  }
 
  async onSignInClick() {
    this.apiErrors = [];
    this.signingInWithPassword = true;
    
    try {
        const loginResult = await this.$store.dispatch(
          'auth/authRequest', 
          {username: this.model.username, password: this.model.password}
        );
        await this.onLoginSuccess();
    } catch (e) {
      this.apiErrors = AppEvents.getApiErrorsFromError(e);
      console.error("loginError", e);
    }
    this.signingInWithPassword = false;
  }

  async onAzureAdSignInClick() {
    this.signingInWithAzureAd = true;
    const routeOptions = { name: Routes.signInAzureAdRoute.name, query: this.$route.query };
    const route = this.$router.resolve(routeOptions);
    const callbackUrl = new URL(route.href, window.location.href).href;
    console.log(callbackUrl);

    const backendAzureAdLoginUrl = [
      process.env.VUE_APP_API_HOST,
      "/ExternalAuth/AzureAdSignIn",
      "?callbackUrl=",
      encodeURIComponent(callbackUrl),
    ]
    .concat(
      this.isValidEmail(this.model.username)
      ? [
          "&loginHint=",
          encodeURIComponent(this.model.username)
        ]
      : []
    ).join("");
   
    console.log(backendAzureAdLoginUrl);
    document.location.href = backendAzureAdLoginUrl;
    // No need to set signingInWithAzureAd to false, the entire page will now load with another URL
  }

  isValidEmail(email: string): boolean {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,16})+$/.test(email); 
  }

  async onLoginSuccess(){
    await this.$store.dispatch('user/getMe');
    const me: User = (this.$store.state as any).user.me as User;
    this.$root.$emit(AppEvents.APP_LOGIN_SUCCESS);
    
    // check if user has organization access
    if (me.organizationIds && me.organizationIds.length > 0) {
      this.$router.push({
        name: Routes.organizationRoute.name,
        params: {
          organizationId: me.organizationIds[0],
        },
      });
    } else {
      if (this.$route.query && this.$route.query.redirect){
        this.$router.push(this.$route.query.redirect.toString());
      } else {
        this.$router.push(Routes.rootRoute);
      }
    }
  }
};
